import React from "react"

import { Row, Col } from "react-bootstrap"

import { formatDate } from "../../utils/format-date-time"

const TimelineExperienceInfo = ({ data }) => {
  return (
    <div className="timeline-info">
      <Row>
        <Col lg="5">
          <h5>{data.company ? data.company : ""}</h5>
          <p>
            {formatDate(data.started_on)} -{" "}
            {data.ended_on ? formatDate(data.ended_on) : "Current"}
          </p>
          <p>{data.description ? data.description : ""}</p>
        </Col>
        <Col lg="5">
          <p className="designation">
            {data.position ? data.position : "Position not available."}
          </p>
        </Col>
      </Row>
    </div>
  )
}

export default TimelineExperienceInfo
